import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

import { Contacts } from '@usimweb/core/models';
import { Projects, RoleType } from '@usimweb/core/models';

import { Store } from '@ngrx/store';
import { skip } from 'rxjs';
import * as fromStore from '@usimweb/state/store';
import { AuthHandler } from '@usimweb/core-auth';

//@ts-ignore
import * as _ from 'lodash';
@Component({
    selector: 'usimweb-share-dialog',
    templateUrl: './share-dialog.component.html',
    styleUrls: ['./share-dialog.component.scss'],
    standalone: false
})
export class ShareDialogComponent implements OnInit {
  private user: string = '';
  private sharingRights = ['owner', 'reviewer'];

  public project: Projects = {} as Projects;
  public isDataLoaded = false;
  public title: string = '';
  public projectName: string = '';
  public uuid: string;
  public email: string = '';

  public curveColumnsTable: string[] = ['user', 'mail', 'toggle', 'rights'];
  public dataTableSource!: MatTableDataSource<Contacts>;

  public showInfo: boolean = false;
  public isOwner_: boolean = false;
  public role: string = '';
  public users: string[] = [];
  public users_roles: { [key in string]: string } = {};

  constructor(
    private store: Store<fromStore.DashboardState>,
    private dialogRef: MatDialogRef<ShareDialogComponent>,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) data: unknown
  ) {
    const obj = data as { data: { uuid: string; title: string; project: Projects; user: string } };

    this.user = obj.data.user;
    this.uuid = obj.data.uuid;
    this.projectName = obj.data.project.name || '';
    this.project = obj.data.project;
  }

  ngOnInit(): void {
    this.title = 'Share project: ' + this.projectName;
    this.assignUsers(1);
  }

  private isOwner(projects: Projects) {
    const created_by = projects.created_by?.toLocaleLowerCase();

    if (this.user === created_by) {
      this.isOwner_ = true;
    }

    if (projects.user_roles[this.user]) {
      this.role = projects.user_roles[this.user];
    }
  }

  private assignUsers(skips = 0) {
    this.store.dispatch(new fromStore.LoadProjectContacts(this.uuid));
    this.store
      .select(fromStore.getContacts)
      .pipe(skip(skips))
      .subscribe((contacts) => {
        this.isDataLoaded = true;
        this.dataTableSource = new MatTableDataSource<Contacts>(contacts);

        const project = this.project as Projects;
        this.isOwner(project);

        if (contacts.length > 0) {
          this.users = this.project.users;
          this.users_roles = this.project.user_roles;
          this.dataTableSource = new MatTableDataSource<Contacts>(contacts);
        }

        if (contacts.length === 0) {
          this.showInfo = true;
        }
      });
  }

  public get disableSharing(): boolean {
    const userRoles = _.transform(this.project.user_roles, function (result: any, val: any, key: any) {
      result[key.toLowerCase()] = val;
    });
    return !this.sharingRights.includes(userRoles[this.user]);
  }

  public inviteUser() {
    this.store.dispatch(new fromStore.CreateRequest(this.email));
    const sub = this.store
      .select(fromStore.getContacts)
      .pipe(skip(1))
      .subscribe(() => {
        sub.unsubscribe();
        this.dataTableSource._updateChangeSubscription();
      });
  }

  public toggleSharing(event: MatSlideToggleChange, contact: Contacts) {
    // if (event.checked) {
    //   document.documentElement.style.setProperty('--toggle-handle-color', '#21a0d2');
    // } else {
    //   document.documentElement.style.setProperty('--toggle-handle-color', 'grey');
    // }
    if (contact!.username) {
      const sharing = { data: { username: contact.username }, uuid: this.uuid };
      if (event.checked) {
        this.store.dispatch(new fromStore.AddUserProjects(sharing));
        this.store
          .select(fromStore.getProjectById(this.uuid))
          .pipe(skip(1))
          .subscribe((project) => {
            this.project = project;
            this.assignUsers(1);
            this.snackBar.open('Sharing now project with user: ' + sharing.data.username + '...', 'OK', {
              duration: 2000,
            });
          });
      } else {
        this.store.dispatch(new fromStore.RmUserProjects(sharing));
        this.store
          .select(fromStore.getProjectById(this.uuid))
          .pipe(skip(1))
          .subscribe((project) => {
            this.project = project;
            this.assignUsers(1);
            this.snackBar.open('User removed from project: ' + sharing.data.username + '...', 'OK', { duration: 2000 });
          });
      }
    }
  }

  public changeRole(contact: Contacts, role: RoleType) {
    const params = {
      role: role,
      username: contact.username,
    };

    const roleObj = { data: params, uuid: this.uuid };
    this.store.dispatch(new fromStore.ChangeUserProjects(roleObj));
    this.store
      .select(fromStore.getProjectById(this.uuid))
      .pipe(skip(1))
      .subscribe((project) => {
        this.snackBar.open('Set user role to: ' + (role == 'reader' ? 'viewer' : 'editor'), 'OK', { duration: 2000 });
        this.project = project;
        this.assignUsers();
      });
  }

  public endParticipation() {
    const sharing = { data: { username: AuthHandler.basfUserName.toLocaleLowerCase() }, uuid: this.uuid };
    this.store.dispatch(new fromStore.RmUserProjects(sharing));
    this.store
      .select(fromStore.getProjectById(this.uuid))
      .pipe(skip(1))
      .subscribe(() => {
        this.snackBar.open('User removed from project' + sharing.data.username + '...', 'OK', { duration: 2000 });
        this.dialogRef.close(false);
      });
  }

  public close() {
    this.dialogRef.close(false);
  }
}
